import { useQuery } from "react-query";
import { useApiService } from "../useApiService";
import { ReferentialApi } from "../../api";
import React from "react";

export function useCountryRef() {
  const api = useApiService(ReferentialApi);
  const { data, isFetching, refetch } = useQuery(
    "ref-countries",
    async () => {
      return api.countries();
    },
    {}
  );

  const belgiumId = React.useMemo(
    () => data?.find((c) => c.keyValue.toUpperCase() === "BE")?.idValue,
    [data]
  );
  return {
    countries: data,
    countriesLoading: isFetching,
    refetchCountriesRef: refetch,
    belgiumId,
  };
}
